import { IsEnum, IsInt, IsOptional } from "class-validator";
import { BudgetPreference } from "./design-project-onboarding-budget.entity";
import { Expose } from "class-transformer";

export class UpdateDesignProjectOnboardingBudgetDto {
  @Expose()
  @IsOptional()
  @IsEnum(BudgetPreference)
  budgetPreference?: BudgetPreference;

  @Expose()
  @IsOptional()
  @IsInt()
  wishlistEstimateLow?: number | null;

  @Expose()
  @IsOptional()
  @IsInt()
  wishlistEstimateHigh?: number | null;

  @Expose()
  @IsOptional()
  @IsInt()
  baseInstallationCostsLow?: number | null;

  @Expose()
  @IsOptional()
  @IsInt()
  baseInstallationCostsHigh?: number | null;
}
